<template>
  <MetaTag />
  <Snackbar />
  <router-view />
</template>
<script>
import MetaTag from '@/components/MetaTag'
import Snackbar from '@/components/helper/Snackbar'
import { mapGetters } from 'vuex'
export default {
  components: {
    MetaTag,
    Snackbar,
  },
  computed: {
    ...mapGetters({
      getisLoggedIn: 'getisLoggedIn'
    })
  },
  mounted(){
    this.$store.dispatch('setIsMobile',window.innerWidth)
    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    })
  },
  unmounted() { 
    window.removeEventListener('resize', this.onResize); 
  },
  methods: {
    onResize() {
      this.$store.dispatch('setIsMobile',window.innerWidth)
    },
    async gotoRoute(name){
      try{
        await this.$router.push({name})
      }catch(_){
        await this.$router.push({name: 'NotFound', })
      }
    }
  }
}
</script>